/*******************************************************
 * UTILS SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")


	.factory("TableSortingService", function () {

			/**
			 * Modifie l'order.
			 * Si déja selectionné, inverse le sens, sinon applique le nouveau dans le sens +
			 *
			 * @param currentOrder
			 * @param order
			 * @returns {string}
			 */
			const changeOrder = (currentOrder, order) => {
				if (currentOrder.endsWith(order)) {
					if (currentOrder.startsWith("+")) {
						return "-" + order;
					} else {
						return "+" + order;
					}
				} else {
					return "+" + order;
				}
			};

			/**
			 * Retourne le template de l'icone de fleche a afficher
			 *
			 * @param currentOrder
			 * @param order
			 * @returns {string}
			 */
			const getArrowIconForOrder = (currentOrder, order) => {
				if (currentOrder.match('[\+\-]' + order)) {
					if (currentOrder.startsWith("+")) {
						return "<span class=\"fa fa-arrow-down\"></span>";
					} else {
						return "<span class=\"fa fa-arrow-up\"></span>";
					}
				} else {
					return "";
				}
			};

			return {
				changeOrder: changeOrder,
				getArrowIconForOrder: getArrowIconForOrder,
			};

		}
	);
